import { Disclaimer } from '@/components/BlackFriday/Disclaimer'
import { Image } from '@/components/Image'
import { BodyM, HeadingL } from '@/components/Typography'

import { CONTAINER_BLACK_FRIDAY_PROPS } from '../constants'
import { DISCLAIMER_TEXTS } from '../Disclaimer/constants'

import { MEDIA } from './constants'

import {
  MediaContainer,
  SectionButtonLink,
  SectionContentContainer,
  SectionFooter,
  SectionTextContainer,
} from './styles'

const Media = () => (
  <MediaContainer {...CONTAINER_BLACK_FRIDAY_PROPS} contentClassName="media-content">
    <Image {...MEDIA.image} alt="Juiz apitando" />
    <SectionContentContainer>
      <SectionTextContainer>
        <HeadingL light="solid" tag="h2">
          Relatório de Consultas ao CPF
        </HeadingL>
        <BodyM light="solid">
          Veja todas as consultas feitas ao seu CPF e, se não reconhecer alguma empresa, tenha tempo
          de agir e se proteger!
        </BodyM>
      </SectionTextContainer>
      <SectionButtonLink rounded modifier="solid" source={MEDIA.cta.href}>
        Baixar grátis
      </SectionButtonLink>
      <SectionFooter>
        <Disclaimer
          id="media-footer-disclaimer"
          text={DISCLAIMER_TEXTS.consultationReport.text}
          accessibleText={DISCLAIMER_TEXTS.consultationReport.accessibleText}
          light="solid"
          className="media__footer__disclaimer"
        />
      </SectionFooter>
    </SectionContentContainer>
  </MediaContainer>
)

export default Media
